import api from '../../utils/apiFetch';

const path = 'catalog';
const localBusinessId = 'f888bb54-5e70-4767-98f0-1a3b4a04d7b2';

export default {
  getLocalBusinessCategory: () =>
    api.get(`${path}/categories?type=${localBusinessId}`),
};
